export default {"src":"/_next/static/media/carat-down-24.ed82cfb6.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};